import React, { useCallback, useEffect, useState } from 'react';
import Select from 'react-select';

import { updateDemandActivityAction } from '../../../actions/demand';
import { updateEndpointActivityAction } from '../../../actions/endpoint';
import { fetchAllActivities } from '../../../api/activities';

import './TableActivityCell.scss';

const TableActivityCell = (data) => {
  const value = data.value;
  const firstColumn = data.allColumns[0].Header;
  const id = data.row.original._id;
  const activityId = data.row.original.activity_id;

  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState(null);
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    fetchAllActivities().then((res) => {
      const opts = res.data.map((a) => ({
        label: a.name,
        value: a._id
      }));
      setOptions(opts);
    });
  }, []);

  useEffect(() => {
    if (value && activityId) {
      setSelected({ label: value, value: activityId });
    }
  }, [value, activityId]);

  const handleOnSave = useCallback((e) => {
    e.preventDefault();

    if (!selected) return;

    const fn = firstColumn === 'Endpoint'
      ? updateEndpointActivityAction
      : updateDemandActivityAction;

    fn(id, selected);
    setEditing(false);
  }, [firstColumn, id, selected]);

  const handleOnCancel = useCallback(() => {
    if (value && activityId) {
      setSelected({ label: value, value: activityId });
    } else {
      setSelected(null);
    }
    setEditing(false);
  }, [value, activityId]);

  return (
    <div className="table-activity-cell">
      {editing ? (
        <div className="activity-cell-box">
          <Select
            className='the-field selectable'
            classNamePrefix='react-select'
            onChange={setSelected}
            value={selected}
            isMulti={false}
            options={options}
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          />
          <div className="activity-cell-actions">
            <div onClick={handleOnCancel} className="activity-cell-closing"><i className="fas fa-times"/></div>
            <div onClick={handleOnSave} className="activity-cell-submit"><i className="fas fa-check"/></div>
          </div>
        </div>
      ) : (
        <div className="activity-cell-box">
          <div>{value || '-'}</div>
          <div onClick={() => setEditing(true)} className="activity-cell-action">
            <img title="Edit activity" src={require('../../../assets/images/icons/ico_edit.svg')} alt=""/>
            <img title="Edit activity" className='img-active' src={require('../../../assets/images/icons/ico_edit_o.svg')} alt=''/>
          </div>
        </div>
      )}
    </div>
  );
};

export default TableActivityCell;
